import React from 'react';

import useClassy from '@core/hooks/useClassy';

import Flex from '@ui/Flex';

import classes from './style.module.scss';

interface Props {
  children?: React.ReactNode;
  className?: string;
  heading: React.ReactNode;
  /**
   * Renders the header in a title or subheader style
   */
  kind?: 'subheading' | 'title';
  shift?: string;
}

const APISectionHeader = React.memo(function APISectionHeader({
  children,
  className,
  heading,
  kind = 'subheading',
  ...props
}: Props) {
  const bem = useClassy(classes, 'APISectionHeader');

  if (!heading) {
    return null;
  }

  return (
    <Flex
      align="center"
      className={bem('&', `_${kind}`, 'rm-APISectionHeader', className)}
      gap="4px"
      tag="header"
      {...props}
      wrap="wrap"
    >
      <div className={bem('-heading', kind === 'title' && '-heading_title')}>{heading}</div>
      {children}
    </Flex>
  );
});

export default APISectionHeader;
